<template lang="pug">
  el-main
    el-card(class="box-card")
      // Page Title Header
      div(
        slot="header"
        class="clearfix"
        )
        img(class="typeIcon" :src="typeIcon")
        span(class="form-title") {{ formTitle }}
       
      
      // Question-specific Form Input Fields
      div(class="text item")
        component(
          :is="builderType"
          v-if="pageView === 'create' || pageView === 'edit'"
          :question="questionData"
          :action="pageView"
          :tagsList="tagsList"
          @onProcessing="onProcessing"
          @formCancelClicked="$emit('formCancelClicked')"
          @onQuestionSaved="onQuestionSaved")

</template>

<script>
  import {QUESTION_TYPES} from '@/defines/constants'
  import AnswerInputForm from '@/components/instructor/Question/QuestionForm/AnswerInputForm'
  import CodingForm from '@/components/instructor/Question/QuestionForm/CodingForm'
  import SelectForm from '@/components/instructor/Question/QuestionForm/SelectForm'

  export default {
    name: 'QuestionBuilder',

    components: {
      AnswerInputForm,
      CodingForm,
      SelectForm,
    },

    props: {
      pageView: {
        type: String,
        required: true,
      },

      questionData: {
        type: Object,
        required: true,
      },

      tagsList: {
        type: Array,
        default: () => { return [] },
      },
    },

    data () {
      return {
        pageTitles: {
          create: 'Create Question',
          view: 'View Question',
          edit: 'Edit Question',
        },
        formTitle: 'Page Title',
        typeKey: '',
        typeIcon: null,

        QUESTION_TYPES,

        builderTypes: [
          'None',
          'AnswerInputForm',
          'CodingForm',
          'SelectForm',
        ],
      }
    },

    computed: {
      builderType() {
        return this.builderTypes[this.questionData.type_id]
      },
    },

    mounted() {
      this.formTitle = this.pageTitles[this.pageView]
      this.typeKey = Object.keys(QUESTION_TYPES).find(key => QUESTION_TYPES[key] === this.questionData.type_id)
      this.typeIcon = require(`@/assets/QuestionTypes/${this.typeKey}_Icon.svg`)
    },

    methods: {
      onProcessing(flag) {
        this.$emit('onProcessing', flag)
      },

      onQuestionSaved() {
        this.$emit('onQuestionSaved')
      },
    },
  }
</script>

<style scoped>
  .form-title {
    font-weight: bold; 
    font-size: 20px;
    line-height: 2em;
    vertical-align: top;
    color: #00a8ff;
  }

  .typeIcon {
    width: 45px;
    height: 45px;
    padding-right: 15px;
  }
</style>

<style>
  .text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 100%;
    min-height: 300px;
  }
</style>